export default __webpack_public_path__ + "static/media/irene.6030394a.png";